import React from 'react';

import {
    Select,
    Button,
} from 'antd';

import {
    _getSalesAgents,
} from '../../services'

const { Option } = Select;

class SalesAgentSelector extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            agents: [],
        }
    }

    render() {

        var agents = [...this.state.agents, {
            text: 'Unassigned',
            value: null
        }]

        return (
            <div>
                <Select value={this.props.activeAgent} style={{ width: 240 }} onChange={this.onSelect} >
                    {agents.map(_agent => {
                        return (
                            <Option value={_agent.value}>{_agent.text}</Option>
                        )
                    })}
                </Select>
                <Button onClick={() => this.onRemove()} style={{marginLeft: 8}} type='danger'>
                    Remove
                </Button>
            </div>
        )
    }

    componentDidMount() {

        _getSalesAgents()
        .then(_salesAgents => {

            var agents = _salesAgents.data.reduce((acc,_agent) => {
                var agent = {
                    text: _agent.local.email,
                    value: _agent._id
                }
                return [...acc,agent]
            },[])

            this.setState({
                agents
            })
        })
    }

    findAgent = ({agentId}) => {
        var agent = this.state.agents.filter(_agent => _agent.value == agentId)[0]
        return agent
    }

    onSelect = (value) => {

        if (value==null) {
            this.props.onSelect({ agentId: null, agentEmail: null})
            return
        }

        var agent = this.findAgent({agentId: value})
        this.props.onSelect({ agentId: agent.value, agentEmail: agent.text})
    }

    onRemove = () => {
        this.props.onSelect({ agentId: null, agentEmail: null})
    }
}

export default SalesAgentSelector


// WEBPACK FOOTER //
// ./src/components/enterprise/sales-agent-select.js